/** Image API — Faz 1.4 createApi factory. */
import {createApi} from './_factory'
import type {CommonNs} from '@shared/types'

const api = createApi('image-service')

export interface UploadImageByUrlRequest {
  url: string
  workspaceId: string
  bucketType?: string
}

export interface RemoveImageRequest {
  workspaceId: string
  bucketType: string
  imageKey: string
}

export const ImageApi = {
  uploadImage: (data: FormData) =>
    api.upload<CommonNs.AnyResponse>('upload-image', data),
  uploadImageByUrl: (data: UploadImageByUrlRequest) =>
    api.post<UploadImageByUrlRequest, CommonNs.AnyResponse>('upload-image-by-url', data),
  removeImage: (workspaceId: string, bucketType: string, imageKey: string) =>
    api.post<RemoveImageRequest, CommonNs.AnyResponse>('remove-image', {workspaceId, bucketType, imageKey}),
}
